import { AddIcon, MinusIcon } from '@sketchnote/icons';
import * as React from 'react';
import { preventEvent, TDSnapshot, useTldrawApp } from 'sn-wb-tldraw';
import { DMContent, DMItem } from 'sn-wb-tldraw';

const zoomSelector = (s: TDSnapshot) => s.document.pageStates[s.appState.currentPageId].camera.zoom;

interface ZoomMenuProps {
  hasFollowedUser: boolean;
  updateUserFollowing: any;
}

export const ZoomMenu = React.memo(function ZoomMenu({
  hasFollowedUser,
  updateUserFollowing,
}: ZoomMenuProps) {
  const app = useTldrawApp();

  const zoom = app.useStore(zoomSelector);

  const handleZoom = (status: string) => {
    if (hasFollowedUser) updateUserFollowing('', app.pageState.camera.point);
    if (status === 'in') app.zoomIn();
    else app.zoomOut();
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '18%',
        right: '2%',
        display: 'flex',
        justifyContent: 'space-between',
        background: 'white',
        minWidth: '145px',
        minHeight: '50px',
        border: 'none',
        outline: 'none',
        pointerEvents: 'all',
      }}
    >
      <button
        style={{ outline: 'none', border: 'none', pointerEvents: 'all', backgroundColor: 'white' }}
        onClick={handleZoom.bind(null, 'out')}
        id="TD-Zoom-Zoom_Out"
        className="px-20"
      >
        <MinusIcon wrapperClass="text-gray-600 text-xs block mb-2" />
      </button>
      <button
        style={{
          background: 'white',
          minWidth: '45px',
          pointerEvents: 'all',
          border: 'none',
          outline: 'none',
          alignItems: 'center',
        }}
        onDoubleClick={app.resetZoom}
      >
        {Math.round(zoom * 100)}%
      </button>
      <button
        style={{ outline: 'none', border: 'none', pointerEvents: 'all', backgroundColor: 'white' }}
        onClick={handleZoom.bind(null, 'in')}
        id="TD-Zoom-Zoom_In"
        className="px-20"
      >
        <AddIcon wrapperClass="text-gray-600 text-sm" />
      </button>
    </div>
  );
});
